import TrustBadgePill from './TrustBadgePill';

export default function ShippingBadge() {
  return <TrustBadgePill id="rapid_delivery" />;
}
